import SearchBar from "./search";

export default SearchBar